module.exports = __webpack_public_path__ + "static/media/industries-mining-s.edd70ca3.webp";